<template>
  <div id="app" :class="[environmentClass, 'd-flex flex-column']" >
    <vue-progress-bar></vue-progress-bar>
    <component :is="layout">
    </component>
    <notifications classes="vue-notification notification"/>
  </div>
</template>

<script>
const defaultLayout = 'default';

export default {
  name: 'App',
  computed: {
    environmentClass() {
      if (process.env.VUE_APP_ENVIRONMENT === 'mirror') {
        return 'mirror';
      }
      return '';
    },
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
  },

  mounted() {
    this.$Progress.finish();
  },

  created() {
    this.$Progress.start();
  },
};
</script>

<style lang="scss">
  #app {
    height: 100%;

    &.mirror {
      &:before {
        content: 'MIRROR';
        display: block;
        width: 100%;
        text-align: center;
        background: $red;
        color: white;
        font-size: 14px;
        z-index: 9999;
      }

      &:after {
        content: 'MIRROR';
        display: block;
        width: 100%;
        text-align: center;
        background: $red;
        color: white;
        font-size: 14px;
        z-index: 9999;
        position: absolute;
        top: 0;
      }
    }

    .dropdown-toggle-no-caret::after {
      display: none;
    }
  }
</style>
